import { useState } from "react";
import { emitErrorToast } from "../../lib/errorToast";
import { Button } from "../Button";

type Props = {
  disabled?: boolean;
  onGenerate: (privateKey: string, publicKey: string) => Promise<unknown>;
};

export function GeneratePrivateKeyButton({ disabled, onGenerate }: Props) {
  const [generating, setGenerating] = useState(false);

  const generate = async () => {
    setGenerating(true);
    try {
      const keyPair = await crypto.subtle.generateKey(
        { name: "ECDSA", namedCurve: "P-256" },
        true,
        ["sign", "verify"]
      );
      const privateKey = await crypto.subtle.exportKey(
        "jwk",
        keyPair.privateKey
      );
      const publicKey = new Uint8Array(
        await crypto.subtle.exportKey("raw", keyPair.publicKey)
      );
      const encodedPublicKey = btoa(String.fromCharCode(...publicKey))
        .replaceAll("+", "-")
        .replaceAll("/", "_")
        .replace(/=+$/, "");
      await onGenerate(privateKey.d!, encodedPublicKey);
    } catch {
      emitErrorToast({
        icon: "key",
        message:
          "Failed to generate or save the private key. Please try again.",
        buttonLabel: "Dismiss",
      });
    }
    setGenerating(false);
  };

  return (
    <Button
      type="button"
      variant="primary"
      size="l"
      disabled={disabled || generating}
      onClick={generate}
    >
      {generating ? "Generating…" : "Generate private key"}
    </Button>
  );
}
